import { render } from "./ProjectModel.vue?vue&type=template&id=64f636c6&scoped=true"
import script from "./ProjectModel.vue?vue&type=script&lang=js"
export * from "./ProjectModel.vue?vue&type=script&lang=js"

import "./ProjectModel.vue?vue&type=style&index=0&id=64f636c6&lang=scss&scoped=true"
import "./ProjectModel.vue?vue&type=style&index=1&id=64f636c6&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f636c6"]])

export default __exports__